import { getBaseurl } from "@/utils/url-parse";
import { useEffect, useState } from "react";
import { Request, Response } from "../../api/request";

// 报送信息数据类型
export interface ReportInfo {
  name: string; // 报送受名名称
  filingAmount: number; // 报送金额，比如: 100.00
  filingAmountStr: string; // 报送金额，比如:100.00元
  filingTimeStr: string; // 报送时间描述，比如:2025年1月1日
  filingPeriodStr: string; // 报送业务时间，比如:2025年第3季度
}

// API 响应数据类型
export type ReportListResponse = Response<ReportInfo[]>;

/**
 * 获取客户收入报送列表
 */
export const queryReportList = async (): Promise<ReportInfo[]> => {
  try {
    const res: ReportListResponse = await Request({
      url: `${getBaseurl()}/api/finance/customer/filing/income/list`,
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (res.success && res.data) {
      return res.data;
    }
    return [];
  } catch (error) {
    console.error("获取报送列表失败:", error);
    return [];
  }
};

/**
 * 互联网报告数据 Hook
 * @param autoLoad 是否自动加载数据，默认为 true
 */
const useReport = (autoLoad = true) => {
  const [reportList, setReportList] = useState<ReportInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  /**
   * 获取报送列表数据
   */
  const fetchReportList = async () => {
    setLoading(true);
    setError("");

    try {
      const data = await queryReportList();
      setReportList(data);
    } catch (err: any) {
      const errorMessage = err?.message || "获取报送列表失败";
      setError(errorMessage);
      console.error("获取报送列表失败:", err);
    } finally {
      setLoading(false);
    }
  };

  /**
   * 刷新数据
   */
  const refresh = () => {
    fetchReportList();
  };

  // 组件挂载时自动加载数据
  useEffect(() => {
    if (autoLoad) {
      fetchReportList();
    }
  }, [autoLoad]);

  return {
    reportList,
    loading,
    error,
    refresh,
    fetchReportList,
  };
};

export default useReport;
